import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

import { settingsMenuItems } from '../../utils/constants';
import { hasAnyModuleAccess } from '../../utils/helpers';

const useStyles = makeStyles({
    menu: {
        marginTop: '2.19rem',
    },
});

export const SettingsSubmenu = ({ isSubmenu, setIsSubmenu }) => {
    const { menu } = useStyles();
    const history = useHistory();
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = path => {
        setAnchorEl(null);
        setIsSubmenu(null);
        history.push(path);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setIsSubmenu(null);
    };

    useEffect(() => {
        setAnchorEl(isSubmenu);
    }, [isSubmenu]);

    return (
        <Menu className={menu} anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
            {settingsMenuItems
                .filter(item => item.visibleToAllUsers || hasAnyModuleAccess(item.permissions))
                .map(item => (
                    <MenuItem key={item.path} onClick={() => handleClick(item.path)}>
                        {item.label}
                    </MenuItem>
                ))}
        </Menu>
    );
};

export default SettingsSubmenu;
